





















import Vue from 'vue';
import { mapGetters } from "vuex";

export default Vue.extend({
  name: 'OctMessageSnackBar',
  data: () => ({
    snackbar: false,
    timeout: 5000,
  }),
  computed: {
    ...mapGetters(['MESSAGETEXT', 'COLOR'])
  },
  watch: {
    MESSAGETEXT(newValue, oldValue) {
      this.snackbar = true;
      this.timeout = 5000;
    },
  },

});
